import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface NewConflictsDialogProps {
  open: boolean;
  reopenedCount: number;
  onClose: () => void;
}

const NewConflictsDialog = ({
  open,
  reopenedCount,
  onClose,
}: NewConflictsDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="mr-new-conflicts-title"
      aria-describedby="mr-new-conflicts-body"
    >
      <DialogTitle id="mr-new-conflicts-title">New conflicts found</DialogTitle>
      <DialogContent>
        <DialogContentText id="mr-new-conflicts-body">
          {`New conflicts were found since you started resolving. ${reopenedCount} cell(s) need a decision again.`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewConflictsDialog;
